import { getChatClient } from '../utils/grpc';

export function getRoomList(username: string) {
  return getChatClient({ username })
    .GetOrgChatRooms({ username })
    .then((res) => res.rooms);
}

export function getRoom(username: string, id: string) {
  return getChatClient({ username }).GetRoomInfo({ username, id });
}

export function deleteRoom(username: string, id: string) {
  return getChatClient({ username }).DeleteChatRoom({ username, id });
}

export function postCreateRoom(username: string, name: string, allow_user_ids: string[]) {
  return getChatClient({ username }).CreateChatRoom({ name, username, allow_user_ids });
}

export function postMessage(username: string, room_id: string, message: Chat.Message[], to_user_ids?: string[]) {
  return getChatClient({ username }).PushMessage({ room_id, message, to_user_ids, username });
}

export function patchUpdateRoom(username: string, room_id: string, name: string, allow_user_ids?: string[]) {
  return getChatClient({ username }).UpdateChatRoom({ room_id, name, allow_user_ids, username });
}
